import React from "react";
import { NavItem, NavLink } from "react-bootstrap";

const AboutTabItem = ({ title, eventKey, key }) => {
  return (
    <>
      <NavItem
        key={key}
        style={{
          width: "250px",
          background:"#b7124d"
        }}
      >
        <NavLink eventKey={eventKey}>{title}</NavLink>
      </NavItem>
    </>
  );
};

export default AboutTabItem;
